import { GridColDef } from '@mui/x-data-grid-pro'
import { getCodeSetLabelLookup } from '../../../Functions/CodeSetFns'
import { ScreenManageDGSampleStatusChips } from './ScreenManageDGSampleStatusChips'
import { ScreenManageDGHoldingChips } from './ScreenManageDGHoldingChips'
import * as React from 'react'
import {
  tsLoginConfig,
  tsScreenHoldings,
  tsScreenSampleStatus,
} from '../../../Typescript/API_Response'
import ViewRequestButton from './ActionButtons/ViewRequestButton'
import CloneButton from './ActionButtons/CloneButton'
import { screenSampleStatuses } from '../ManageCollections/ScreenManageRenderFunctions'

export function screenManageDGCols(
  loginConfig: tsLoginConfig | undefined,
  sampleStatus: tsScreenSampleStatus[],
  holdings: tsScreenHoldings[],
) {
  const collectionCols: GridColDef[] = [
    {
      field: 'ScreenID',
      headerName: 'Screen ID',
      flex: 1 / 2,
    },
    {
      field: 'Name',
      headerName: 'Request Name',
      flex: 2,
    },
    {
      field: 'BillingStatus',
      headerName: 'Billing Status',
      flex: 1,
      valueFormatter: (value) =>
        getCodeSetLabelLookup(loginConfig, ['ScreenBillingStatusID'], value),
    },
    {
      field: 'CollectionStatus',
      headerName: 'Collection Status',
      flex: 1,
      valueFormatter: (value) =>
        getCodeSetLabelLookup(loginConfig, ['ScreenCollectionStatusID'], value),
    },
    {
      field: 'SampleStatus',
      headerName: 'Sample Status',
      minWidth: 200,
      flex: 1,
      renderCell: (params) => <ScreenManageDGSampleStatusChips {...params} />,
      valueGetter: (value) => screenSampleStatuses(value, sampleStatus),
    },
    {
      field: 'HoldingID',
      headerName: 'Holdings',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => (
        <ScreenManageDGHoldingChips
          {...params}
          holdings={holdings}
        />
      ),
    },
  ]
  if (loginConfig?.Modules?.EditScreenRequest) {
    collectionCols.push({
      field: 'actions',
      headerName: 'Actions',
      type: 'actions',
      getActions: (params) => {
        const cols = [<ViewRequestButton {...params} />]
        if (params.row.CollectionStatus !== 'DFT') {
          cols.push(<CloneButton {...params} />)
        }
        return cols
      },
    })
  }
  return collectionCols
}
